export default function RightArrowIcon() {
   return (
      <>
         <svg
            width="37"
            className="img-fluid"
            height="37"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <g clipPath="url(#clip0_5116_214025)">
               <path
                  d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                  fill="#F4F2F0"
               />
            </g>
            <defs>
               <clippath id="clip0_5116_214025">
                  <rect
                     width="36"
                     height="36"
                     fill="white"
                     transform="translate(0.507812 0.324219)"
                  />
               </clippath>
            </defs>
         </svg>
      </>
   )
}
